import { TCombinedDropdownLabel } from '@elements/FnDropdown/types';
import React from 'react';
import { SpanSelection } from './styles';

export const getInitialValue = (
  value: any,
  options: Record<string, any>[],
  propertyValue: string,
  propertyLabel: string,
  propertiesLabelCombined: TCombinedDropdownLabel
): JSX.Element | string => {
  const option = options.find((option) => option[propertyValue] === value);

  if (!option) {
    return null;
  }

  if (propertiesLabelCombined === null) {
    return option[propertyLabel];
  } else {
    return (
      <>
        <SpanSelection>
          {option[propertyLabel][propertiesLabelCombined.selectedLabel]}
        </SpanSelection>
        {option[propertyLabel][propertiesLabelCombined.label]}
      </>
    );
  }
};

export const getSortItem = (
  sortItem: Record<string, any>,
  propertyLabel: string,
  propertiesLabelCombined: TCombinedDropdownLabel
): JSX.Element | string => {
  if (propertiesLabelCombined === null) {
    return sortItem[propertyLabel];
  } else {
    return (
      <>
        <SpanSelection>{sortItem[propertyLabel][propertiesLabelCombined.selectedLabel]}</SpanSelection>
        {sortItem[propertyLabel][propertiesLabelCombined.label]}
      </>
    );
  }
};
